"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.configType = void 0;
var _propTypes = require("prop-types");
const configType = exports.configType = (0, _propTypes.shape)({
  enable_hide_scheduling_help_messages: _propTypes.bool,
  recaptchaSiteKey: _propTypes.string.isRequired,
  render_type: _propTypes.string
});